import React, { useEffect, useState, useMemo } from 'react';
import { Typography } from '@telus-uds/components-web';
import { Table, Td, Tr, Th, TdImp } from './css.js';
import { FieldSchema } from './fieldSchema.js';
import { get, round } from 'lodash';

const TableCS = ({
  onChange,
  orderData,
  defaultValues,
  tableCybersecurityError,
  isFormTouched,
  setIsFormTouched,
  setShowDownloadQuoteFooter,
  disabledFields = {}
}) => {
  const [fieldData, setFieldData] = useState({});

  const onInputChange = (event, name, price) => {
    const value = event.target.value;
    if (!value.includes('-')) {
      const quantity = Number(value);
      setFieldData({
        ...fieldData,
        [name[0]]: {
          ...fieldData[name[0]],
          [name[0]]: quantity,
          [name[1]]: quantity > 0 ? quantity * price : 0,
          price: quantity > 0 ? price : 0
        }
      });
  
      if (!isFormTouched) {
        setIsFormTouched(true);
        setShowDownloadQuoteFooter(false);
      }
    }
  };

  const totals = useMemo(() => {
    let totalCostSum = 0;
    Object.entries(fieldData).forEach(([key, value]) => {
      const price = Number(
        value && value[`${key}Price`] ? value[`${key}Price`] : 0
      );
      if (price > 0) {
        totalCostSum += round(price, 2);
      }
    });
    return {
      totalCost: totalCostSum
    };
  }, [fieldData]);

  useEffect(() => {
    onChange({
      selection: fieldData,
      totalPrice: totals.totalCost
    });
  }, [totals]);

  useEffect(() => {
    setFieldData(get(defaultValues, 'selection', []));
  }, [orderData]);

  return (
    <Table>
      <Tr>
        <Td> </Td>
        <Td><Typography>Quantity</Typography></Td>
        <Td><Typography>Total Price</Typography></Td>
      </Tr>
      {FieldSchema.map((rowItem, rowIndex) => {
        return (
          <Tr>
            <TdImp>
              <Typography heading="h4" variant={{ size: 'h4' }}>
                {rowItem.text} {rowItem.isRequired ? '*' : '' }
              </Typography>
              <span
                style={{
                  display: 'block',
                  fontWeight: 'lighter',
                  fontStyle: 'italic',
                  fontSize: '13px'
                }}
              >
                {rowItem.note ? rowItem.note : ''}
              </span>
            </TdImp>
            <Th>
              <input
                id={rowItem.name[0]}
                name={rowItem.name[0]}
                type="Number"
                onWheel={e => e.target.blur()}
                value={
                  fieldData[rowItem.name[0]] &&
                  fieldData[rowItem.name[0]][rowItem.name[0]] !== undefined
                    ? fieldData[rowItem.name[0]][rowItem.name[0]]
                    : ''
                }
                placeholder={rowItem.placeholder}
                className="frg-input-field color-light"
                style={{ width: '100%' }}
                onChange={e => onInputChange(e, rowItem.name, rowItem.price)}
                disabled={disabledFields[rowItem.name[0]]}
              />
              <span
                style={{
                  display: 'block',
                  fontWeight: 'lighter',
                  fontSize: '15px',
                  color: 'red'
                }}
              >
                {tableCybersecurityError[rowItem.name[0]]
                  ? tableCybersecurityError[rowItem.name[0]]
                  : ''}
              </span>
            </Th>
            <Th>
              <input
                id={rowItem.name[1]}
                name={rowItem.name[1]}
                type="string"
                onWheel={e => e.target.blur()}
                value={`$ ${
                  fieldData[rowItem.name[0]] &&
                  fieldData[rowItem.name[0]][rowItem.name[1]] !== undefined
                    ? Number(fieldData[rowItem.name[0]][rowItem.name[1]]).toFixed(2)
                    : (0).toFixed(2)
                }`}
                className="frg-input-field color-light"
                style={{ width: '100%' }}
                disabled
              />
            </Th>
          </Tr>
        );
      })}
    </Table>
  );
};

export default TableCS;
